"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const UserContext_1 = require("context/UserContext");
const useModalObjectives_1 = __importDefault(require("hooks/useModalObjectives"));
const HelperUtils_1 = require("utils/HelperUtils");
const FormattedNumber_1 = __importDefault(require("components/design-system/FormattedNumber"));
const Shimmer_1 = __importDefault(require("components/design-system/shimmer/Shimmer"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const TotalWeight = ({ objectiveId, objectiveConfigs, useFixedWidth, useCompactLayout, isWeightEditable = true, modalCustomParams, modalEventOnUpdate }) => {
    const [totalWeight, setTotalWeight] = (0, react_1.useState)(0);
    const { config } = (0, UserContext_1.useUser)();
    const showModalAdjustWeight = (0, useModalObjectives_1.default)((state) => state.showModal);
    const { maxSumOfObjectivesWeightPercentageOn: maxSumOfObjectivesOnBasedOnCategory } = config.objectivesConfig;
    const { maxWeight } = objectiveConfigs;
    const isWarningWeight = maxSumOfObjectivesOnBasedOnCategory && totalWeight > maxWeight;
    const propsModalAdjustWeight = Object.assign(Object.assign({ maxSumOfObjectivesOnBasedOnCategory: maxSumOfObjectivesOnBasedOnCategory, maxSumOfObjectivesBasedOnCategory: maxWeight, isShowWarning: isWarningWeight, isIndividual: false, isSubGoal: true, className: 'show-adjust-weight-modal' }, (modalCustomParams && { customParams: modalCustomParams })), (modalEventOnUpdate && { eventOnUpdate: modalEventOnUpdate }));
    const fetchChildrenWeight = () => {
        const query = {
            metadata: 'weight'
        };
        return (0, ObjectivesClient_1.getObjectiveChildren)(objectiveId, query);
    };
    const { isFetching } = (0, react_query_1.useQuery)(['overallProgress', 'totalWeight', objectiveId], fetchChildrenWeight, {
        onSuccess: (data) => {
            var _a, _b, _c, _d;
            if ((_a = data === null || data === void 0 ? void 0 : data.metadata) === null || _a === void 0 ? void 0 : _a.metadata) {
                setTotalWeight((_d = (_c = (_b = data === null || data === void 0 ? void 0 : data.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.weight) === null || _d === void 0 ? void 0 : _d.total);
            }
        }
    });
    return isFetching ? (react_1.default.createElement(Shimmer_1.default, { width: "168px", height: "16px" })) : (react_1.default.createElement("div", { className: `flex flex-row ${useFixedWidth ? 'min-w-[168px]' : 'w-auto'} ${useCompactLayout ? 'items-start' : 'items-center'}` },
        react_1.default.createElement("div", { className: `flex ${useCompactLayout
                ? 'flex-col gap-[8px] w-auto'
                : 'flex-row items-center'}` },
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement(TooltipContainer_1.default, { classContainer: `flex flex-row items-center ${isWarningWeight ? 'cursor-pointer' : ''} `, show: isWarningWeight, text: `Must be ${(0, HelperUtils_1.getNumberLocale)(maxWeight)}%`, dataCy: "overall-total-weight" }, isWarningWeight && (react_1.default.createElement(SVGIcon_1.default, { customClass: "mr-[4px]", iconName: "icon-warning", fillColor: "var(--y-500)", size: 16 }))),
                react_1.default.createElement(FormattedNumber_1.default, { number: totalWeight, minDecimalLength: 0, customClass: `typography-h400 ${isWarningWeight ? 'text-r-600' : 'text-n-900'} `, dataCy: "weight" }),
                react_1.default.createElement("p", { className: `typography-h400 ${isWarningWeight ? 'text-r-600' : 'text-n-900'} ` }, "%")),
            react_1.default.createElement("p", { className: `${useCompactLayout ? '' : 'ml-[4px]'} typography-h400 text-n-600`, "data-cy": "weight-title" }, (0, HelperUtils_1.getObjectiveLocale)('Total Weight'))),
        react_1.default.createElement("div", { className: "flex flex-row items-center cursor-pointer ml-[12px]", "data-cy": "adjust-weight", onClick: () => showModalAdjustWeight({
                modalType: 'adjustWeight',
                props: propsModalAdjustWeight
            }) }, isWeightEditable && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SVGIcon_1.default, { size: 16, fillColor: "var(--base-600)", iconName: "icon-create" }),
            react_1.default.createElement("p", { className: "typography-link text-base-600 ml-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)('Update weight').toLowerCase()))))));
};
exports.default = TotalWeight;
